import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import axios from 'axios';
import download from 'downloadjs';
import { BiX, BiPrinter, BiDownload } from 'react-icons/bi';
import Loading from '../common/Loading';

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 3000;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ModalBox = styled.div`
  background: white;
  border-radius: 16px;
  width: 1024px;
  height: 90vh;
  display: flex;
  flex-direction: column;
  position: relative;
  animation: fadeIn 0.2s ease;
  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: translateY(0); }
  }
  @media (max-width: 768px) {
    width: 96vw;
    height: 85vh;
  }
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  border-bottom: 1px solid #e5e7eb;
`;

const Title = styled.div`
  font-size: 16px;
  font-weight: 700;
  color: #111827;
`;

const BtnGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const ActionBtn = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border: none;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
  background: ${({ $primary }) => ($primary ? '#6366f1' : '#f3f4f6')};
  color: ${({ $primary }) => ($primary ? '#fff' : '#374151')};
  &:hover {
    background: ${({ $primary }) => ($primary ? '#4f46e5' : '#e5e7eb')};
  }
`;

const CloseBtn = styled.div`
  cursor: pointer;
  color: #6b7280;
  display: flex;
  &:hover { color: #111827; }
`;

const IframeWrap = styled.div`
  flex: 1;
  overflow: hidden;
  border-radius: 0 0 16px 16px;
`;

const PdfPreviewModal = ({ orderId, docId, onClose }) => {
  const [pdfSrc, setPdfSrc] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPdf = async () => {
      try {
        const { data } = await axios.get(`/admin/users/orderlist/download/${docId}`);
        setPdfSrc(data);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    };
    fetchPdf();
  }, [docId]);

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = ''; };
  }, []);

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) onClose();
  };

  const handlePrint = () => {
    const iframe = document.getElementById('pdf-preview-iframe');
    if (iframe) {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
    }
  };

  const handleDownload = () => {
    if (pdfSrc) {
      download(pdfSrc, `슈퍼트랙_발주서_${orderId}.pdf`, 'application/pdf');
    }
  };

  return (
    <Overlay onClick={handleOverlayClick}>
      <ModalBox>
        <Header>
          <Title>발주서 - {orderId}</Title>
          <BtnGroup>
            <ActionBtn onClick={handlePrint}>
              <BiPrinter size={16} /> 인쇄
            </ActionBtn>
            <ActionBtn $primary onClick={handleDownload}>
              <BiDownload size={16} /> 저장
            </ActionBtn>
            <CloseBtn onClick={onClose}><BiX size={24} /></CloseBtn>
          </BtnGroup>
        </Header>
        <IframeWrap>
          {loading ? (
            <div style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Loading />
            </div>
          ) : pdfSrc ? (
            <iframe
              id="pdf-preview-iframe"
              src={pdfSrc}
              title="발주서 미리보기"
              style={{ width: '100%', height: '100%', border: 'none' }}
            />
          ) : (
            <div style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#9ca3af' }}>
              PDF를 불러올 수 없습니다.
            </div>
          )}
        </IframeWrap>
      </ModalBox>
    </Overlay>
  );
};

export default PdfPreviewModal;
